import React from "react";
import ReactDOM from "react-dom";
import Page from "./components/Page";
import { Provider } from "react-redux";
import { configureStore } from "./state/store";
import "./styles.css";

// Needed to fix runtime error when using async/await: https://github.com/parcel-bundler/parcel/issues/2128
import "babel-polyfill";

var mountNode = document.getElementById("app");
const store = configureStore({});
ReactDOM.render(
  <Provider store={store}>
    <Page />
  </Provider>,
  mountNode
);
